import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d632358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { id: "circularProgressContainer" }
const _hoisted_3 = {
  class: "col-xs-8",
  id: "pageTitleContainer"
}
const _hoisted_4 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_5 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_6 = {
  class: "q-py-xs",
  id: "pageContent"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  id: "pdfContent"
}
const _hoisted_9 = { class: "pdfInstructionsContainer" }
const _hoisted_10 = { class: "pdfInstructions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CircularProgress)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.description)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_separator, {
      class: "q-my-md",
      id: "separator"
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", { innerHTML: _ctx.inductionContent }, null, 8, _hoisted_7),
      (_ctx.isPdf)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.isPdfRead && _ctx.isPdfRead(...args))),
              id: "pdfPages"
            }, null, 32),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.pdfInstructionText)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_option_group, {
      id: "radioBtnOptionGroup",
      options: [{ label: _ctx.$t(_ctx.agreeBtnText), value: true }, { label: _ctx.$t(_ctx.disagreeBtnText), value: false }],
      type: "radio",
      modelValue: _ctx.isCompleted,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCompleted) = $event)),
      disable: _ctx.disableOptions
    }, null, 8, ["options", "modelValue", "disable"])
  ], 64))
}